// extracted by mini-css-extract-plugin
export default {"content":"lrCoXs4C8YsmTitxDOjD","actions":"YVYeRQaa73qZnGX65ZRg"};